angular.module('shared').controller('RemainingCharactersDetailsModal', ["$scope", "$modalInstance", function($scope, $modalInstance) {
  $scope.isAccountOwner = window.currentUser.account_owner;
  return $scope.close = function() {
    return $modalInstance.dismiss('cancel');
  };
}]);
